// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2w12_","col":"styles_col__3H34T"};